import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { FlagDetail, flagDetailQuery } from "@/features/feature-flags/components/FlagDetail"

const Params = z.object({
  flagId: z.string(),
})

export const Route = createFileRoute("/(authenticated)/settings/feature-flags/$flagId/")({
  params: Params,
  loader: ({ context, params }) => {
    void context.queryClient.ensureQueryData(flagDetailQuery(params.flagId))
  },
  component: () => {
    const { flagId } = Route.useParams()
    return <FlagDetail flagId={flagId} />
  },
})
